<template>
  <div>
    <custom-actions show-back>
      <el-form class="form" :model="formData" ref="formData" label-width="140px">
        <el-row :span="24">
          <el-col :span="12">
            <el-form-item label="品种规格" prop="specId">
              {{ specName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="配方" prop="productName">
              {{ formData.productName }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="产品编号" prop="productCode">
              {{ formData.productCode }}
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item prop="productType" label="产品类型">
              {{ productTypeMap.get(formData.productType) }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="附件">
              <file-upload readonly v-model="formData.fileList"></file-upload>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="forList" label="产品配方">
              <el-table size="mini" stripe border :data="formData.forList">
                <el-table-column prop="specName" label="品种规格"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="consumeQuantity" label="消耗数量"></el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item prop="outList" label="产品产出">
              <el-table size="mini" stripe border :data="formData.outList">
                <el-table-column prop="specName" label="品种规格"></el-table-column>
                <el-table-column prop="unit" label="单位"></el-table-column>
                <el-table-column prop="outputQuantity" label="消耗数量">
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button @click="$router.back()" class="global-button">取消</el-button>
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
import { managerType, productType } from '@/utils/dict'
export default {
  name: 'ProductManageDetail',
  data() {
    return {
      dialogVisible: false,
      userList: [],
      areaList: [],
      managerTypeMap: managerType,
      productTypeMap: productType,
      specName: '', // 品种规格名称
      formData: {
        specId: '', // 规格id
        productName: '', // 配方
        productCode: '', // 产品编号
        productType: '', // 产品类型 1精炼车间 2包装车间
        fileList: [], // 附件列表
        forList: [], // 产品配方列表
        outList: [] // 产品产出
      }
    }
  },
  computed: {
    productId() {
      return this.$route.query.productId
    },
    productType() {
      return this.$route.query.productType
    }
  },
  created() {
    this.formData.productType = this.productType
    if (this.productId) {
      this.loadDetails()
    }
  },
  methods: {
    loadDetails() {
      this.$axios.get(this.$apis.prodManage.selectScProductByProductId, {
        params: { productId: this.productId }
      }).then(res => {
        this.specName = res.specName
        this.formData = res
      })
    }
  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}

.el-select,
.el-input,
.el-cascader {
  width: 95%;
}

.flex-end {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

.table-form {

  .el-select,
  .el-input,
  .el-cascader,
  .el-input-number {
    width: 100% !important;
  }

  ::v-deep .el-form-item__label {
    display: none;

    &::before {
      display: none;
    }
  }

  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
}
</style>
